import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import { type FC,  } from 'react';
import { gridRowActionsIconProps, } from '@/app/shared/utils/grid';
import { GridColActionsWrapper } from './grid.styles';
import {newGridRecordId} from './overlays/commonFunctions';
import type { IPhoenixGridActions, TPhoenixCellContext } from './utility/types';



interface IGridColActionsProps {
  name?: string;
  canNotCopy?: boolean;
  canNotEdit?: boolean;
  ctx: TPhoenixCellContext;

  pageSize: number;
  // ref?: React.MutableRefObject<GridApiPro>;
  rowActionsSlot?: FC<Record<string, any>>;
  actions?: IPhoenixGridActions;
  onStartEdit: (row: any) => void;
  onSaveClick: (row: any) => void;
  onCancelClick: (row: any) => void;
  onDuplicate: (row: any) => void;
  onDelete: (row: any) => void;
  canDelete?: boolean;
  isEditMode: boolean;
}



export const GridColActions = (
  {
    canNotCopy,
    canNotEdit,
    ctx,
    rowActionsSlot: RowActionsSlot,
    onStartEdit,
    onSaveClick,
    onCancelClick,
    onDuplicate,
    isEditMode,
  }: IGridColActionsProps,
) => {
  const row = ctx.row.original;


  const stop = (event: React.MouseEvent | React.KeyboardEvent) => event.stopPropagation();


  return (
    <GridColActionsWrapper>
      {isEditMode ? (
        <>
          <IconButton
            onClick={(event) => {
              stop(event);
              onSaveClick(row);
            }}
            onKeyUp={(event) => event.key === 'Enter' && onSaveClick(row)}
          >
            <CheckIcon sx={gridRowActionsIconProps} />
          </IconButton>
          <IconButton
            onClick={(event) => {
              stop(event);
              onCancelClick(row);
            }}
            onKeyUp={(event) => event.key === 'Enter' && onCancelClick(row)}
          >
            <CloseIcon sx={gridRowActionsIconProps} />
          </IconButton>
        </>
      ) : (
        <>
          {!canNotEdit && (
            <IconButton data-action="edit-row"
              tabIndex={2}
              onClick={(event) => {
                stop(event);
                onStartEdit(row);
              }}>
              <EditIcon sx={gridRowActionsIconProps} />
            </IconButton>
          )}

          {!canNotCopy && (
            <IconButton disabled={isEditMode}
              tabIndex={2}
              onClick={(event) => {
                stop(event);
                onDuplicate(row);
              }}>
              <ContentCopyIcon sx={gridRowActionsIconProps} />
            </IconButton>
          )}

          {RowActionsSlot && <RowActionsSlot {...row} />}          </>
      )}
    </GridColActionsWrapper>
  );
};
// eslint-disable-next-line react-refresh/only-export-components
export const isNewRow = (row: any) => row?.id === newGridRecordId || row?.isNew;
